module.exports = __webpack_public_path__ + "static/media/apple_icon_black.925ec2dc.svg";